import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "./PubMedSearchIndex.css";
import { keys, isEqual } from 'underscore'
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import '../../../node_modules/react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import '../../../node_modules/react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import '../../../node_modules/react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory from 'react-bootstrap-table2-filter'

import Button from "../../components/Button";
import { popCancelBttn } from "../../assets"
import { Modal } from "react-bootstrap";

class PubMedRightAbstractsDataCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customWidth: props.customWidth,
            customHeight: props.customHeight,
            columns: [],
            abstractsResponse: props.abstractsResponse,
            selected: (props.abstractsSelected && props.abstractsSelected.length > 0) ? props.abstractsSelected : [],
            viewAbstractsDetail: null,
            showPop: false,
            preSelectColmn: this.props.preSelectedValues[this.props.useTemplate],
            checkArray: this.props.preSelectedValues[this.props.useTemplate],
        }
    }
    
    componentDidMount() {
        this.manageGridHeader(this.props.abstractsResponse)
    }
    componentWillReceiveProps(nextProps) {
        if (!isEqual(this.props.abstractsResponse, nextProps.abstractsResponse)) {
            this.setState({
                abstractsResponse: nextProps.abstractsResponse
            }, () => {
                this.manageGridHeader(nextProps.abstractsResponse);
            })
        }
        if (!isEqual(this.props.abstractsSelected, nextProps.abstractsSelected)) {
            this.setState({
                selected: nextProps.abstractsSelected
            })
        }
    }
    handleColumnCheck = (val) => {
        let { checkArray, preSelectColmn } = this.state;
        if (preSelectColmn.indexOf(val) == -1) {
            if (checkArray.indexOf(val) == -1) {
                checkArray = checkArray.concat((val));
                this.setState({ checkArray: checkArray })
                this.props.handleAbstract(checkArray)
            }
            else {
                let checkArrayNew = checkArray.filter(x => x !== val)
                this.setState({ checkArray: checkArrayNew })
                this.props.handleAbstract(checkArrayNew)
            }
        }
    }

    manageGridHeader = (abstractsResponse) => {
        let _allKeys = keys(abstractsResponse[0]);
        let _columns = [];
        _allKeys.map((key) => {
            _columns.push({
                dataField: key,
                text: key,
                headerFormatter: (column, val) => {
                    return (
                        <div 
                            style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <input 
                                type="checkbox" 
                                name="header"
                                checked={(this.state.checkArray.indexOf(column.dataField) === -1) ? false : true} 
                                style={{ marginTop: "2px" }} 
                                onChange={() => this.handleColumnCheck(column.dataField)}>
                            </input>
                            <label for="header" 
                                className="pubmedAbstractsGridHeader" 
                                title={column.dataField} 
                                style={{ marginLeft: "7px" }}
                            >
                                {column.dataField}
                            </label>
                        </div>
                    )
                },
                headerStyle: (colum, colIndex) => {
                    if (key === 'relevant') {
                        return {
                            // border: '1px solid',
                            // width: '190px'
                        };
                    } else {
                        return {}
                    }
                },
                formatter: (value, row, index) => {
                    if (key === 'relevant') {
                        return this.RenderRelevant(value);
                    } else {
                        return (<p className="pubmed-abstracts-cell-value">{value}</p>)
                    }
                },
                hidden: (key === 'processed_merged_abs_body' || key === 'rowIndex' || key === 'userID' || key === 'searchID' || key === 'resultID' || key === 'rli_id'),
            })
        })
        this.setState({ columns: _columns });
    }
    customTotal = (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total">
            Showing {from} to {to} of {size} Results
        </span>
    );
    RenderRelevant = (Relevant) => {
        return (
        <div className="relevant-non-relevant-tag">
            {Relevant === "True" ? (
                <div className="pubmed-search-relevant-outer-box">
                    <div className="pubmed-search-relevant-box">
                        <svg
                            fill="#000000"
                            width="14px"
                            height="14px"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                                id="SVGRepo_tracerCarrier"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                                <path d="M12,1A11,11,0,1,0,23,12,11.013,11.013,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9.011,9.011,0,0,1,12,21ZM17.737,8.824a1,1,0,0,1-.061,1.413l-6,5.5a1,1,0,0,1-1.383-.03l-3-3a1,1,0,0,1,1.415-1.414l2.323,2.323,5.294-4.853A1,1,0,0,1,17.737,8.824Z"></path>
                            </g>
                        </svg>
                        <span className="mx-1">Highly Responsive</span>
                    </div>
                </div>
            ) : (
                <div className="pubmed-search-relevant-outer-box">
                    <div className="pubmed-search-not-relevant-box">
                        {
                            <svg
                                width="14px"
                                height="14px"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g
                                    id="SVGRepo_tracerCarrier"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                ></g>
                                <g id="SVGRepo_iconCarrier">
                                    {" "}
                                    <path
                                        d="M8.00386 9.41816C7.61333 9.02763 7.61334 8.39447 8.00386 8.00395C8.39438 7.61342 9.02755 7.61342 9.41807 8.00395L12.0057 10.5916L14.5907 8.00657C14.9813 7.61605 15.6144 7.61605 16.0049 8.00657C16.3955 8.3971 16.3955 9.03026 16.0049 9.42079L13.4199 12.0058L16.0039 14.5897C16.3944 14.9803 16.3944 15.6134 16.0039 16.0039C15.6133 16.3945 14.9802 16.3945 14.5896 16.0039L12.0057 13.42L9.42097 16.0048C9.03045 16.3953 8.39728 16.3953 8.00676 16.0048C7.61624 15.6142 7.61624 14.9811 8.00676 14.5905L10.5915 12.0058L8.00386 9.41816Z"
                                        fill="#0F0F0F"
                                    ></path>{" "}
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM3.00683 12C3.00683 16.9668 7.03321 20.9932 12 20.9932C16.9668 20.9932 20.9932 16.9668 20.9932 12C20.9932 7.03321 16.9668 3.00683 12 3.00683C7.03321 3.00683 3.00683 7.03321 3.00683 12Z"
                                        fill="#0F0F0F"
                                    ></path>
                                </g>
                            </svg>
                        }
                        <span className="mx-1">Responsive</span>
                    </div>
                </div>
            )}
        </div>)
    }

    handleSelectRow = (row, isSelect) => {
        let _selected = [];
        if (isSelect) {
            _selected = [...this.state.selected, row.rowIndex]
            this.setState(() => ({
                selected: _selected,
            }), this.setErrorStatus);
        } else {
            _selected = this.state.selected.filter(x => x !== row.rowIndex);
            this.setState(() => ({
                selected: _selected,
            }), this.setErrorStatus);
        }

        this.props.handleAbstractSelect(_selected)
    }
    handleSelectAllRow = (isSelect, rows) => {
        const ids = rows.map(r => r.rowIndex);
        if (isSelect) {
            this.setState(() => ({
                selected: ids,
            }), this.setErrorStatus);
        } else {
            this.setState(() => ({
                selected: this.state.selected.filter((el) => !ids.includes(el)), //[],
            }), this.setErrorStatus);
        }
        this.props.handleSelectAll(isSelect)
    }
    handleButtonViewDetails = () => {
        let { selected, abstractsResponse } = this.state;
        if (selected.length === 1) {
            let selectedDetails = abstractsResponse.find(x => x.rowIndex === selected[0]);
            this.setState({ viewAbstractsDetail: selectedDetails, showPop: true })
        }


    }
    renderViewDetails = () => {
        let { viewAbstractsDetail } = this.state;
        return (<table className="table table-bordered">
            <tbody>
                {
                    Object.keys(viewAbstractsDetail).map((viewAbstractItemKey, viewAbstractIndex) => {
                        return (
                            <tr>
                                <th>{viewAbstractItemKey}</th>
                                <td>{viewAbstractsDetail[viewAbstractItemKey]}</td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </table>)
    }

    render() {
        const selectRow = {
            mode: 'checkbox',
            clickToSelect: false,
            onSelect: this.handleSelectRow,
            onSelectAll: this.handleSelectAllRow,
            selected: this.state.selected
        };
        const options = {
            paginationSize: 4,
            pageStartIndex: 1,
            firstPageText: 'First',
            prePageText: 'Back',
            nextPageText: 'Next',
            lastPageText: 'Last',
            nextPageTitle: 'First page',
            prePageTitle: 'Pre page',
            firstPageTitle: 'Next page',
            lastPageTitle: 'Last page',
            showTotal: true,
            paginationTotalRenderer: this.customTotal,
            disablePageTitle: true,
            totalSize: this.state.abstractsResponse.length,
            // totalSize: this.state.products.length,
            sizePerPageList: [{
                text: '5', value: 5
            }, {
                text: '10', value: 10
            }, {
                text: 'All', value: this.state.abstractsResponse.length
            }] // A numeric array is also available. the purpose of above example is custom the text
        };
        if (this.props.customWidth >= 600 && this.props.customWidth <= 1000) {
            return (<></>)
        }
        else if (this.props.customWidth > 1000) {
            return (
                <div className="ms-0 lg:ms-4 grow">
                {(this.state.columns.length > 0 && this.state.abstractsResponse.length > 0) ? 
                    <ToolkitProvider
                        keyField='rowIndex'
                        data={this.state.abstractsResponse}
                        columns={this.state.columns}
                        exportCSV={{ 
                            fileName: 'RegistrationDetails.csv', 
                            onlyExportFiltered: true, 
                            exportAll: false 
                        }}>
                        {props => (
                            <div>
                                {/* <div className="admin-data-function-button-wrapper">
                                    <div className="admin-heading-leftPart">
                                        <span className="admin-console-heading"></span>
                                    </div>
                                    <div className="admin-console-button-container">
                                        <Button text="View Details" isDisabled={!(this.state.selected && this.state.selected.length === 1)} customColor='#2EB000' action={this.handleButtonViewDetails} />
                                    </div>
                                </div> */}
                                <BootstrapTable
                                    {...props.baseProps}
                                    bordered={false}
                                    filter={filterFactory()}
                                    // pagination={paginationFactory(options)}
                                    selectRow={selectRow}
                                    wrapperClasses="table-responsive adminconsole-table"
                                    classes="adminDashboard-table table-bordered"
                                    rowClasses="text-nowrap"
                                >
                                </BootstrapTable>
                            </div>
                        )}
                    </ToolkitProvider> 
                    : 
                <div>
                </div>
            }
                {this.state.showPop && <Modal
                    show={this.state.showPop}
                    size="lg md"
                    //size="md"
                    centered
                    aria-labelledby="contained-modal-title-vcenter"
                    dialogClassName="popup-transition"
                    scrollable={true}>

                    <div style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}>
                        <div className="popup-cancel-btn-wrapper">
                            <img
                                src={popCancelBttn}
                                alt=""
                                onClick={e => {
                                    this.setState({ showPop: false });
                                }}
                            />
                        </div>
                        <div>
                            <Modal.Header className="gsfModalHeader" style={{ justifyContent: "left" }}>
                                <div style={{ textAlign: "center", width: "70%", paddingTop: "1%" }}>
                                    <Modal.Title>
                                        <div className="upload-abstracts-actionItem-headerPart">
                                            <div className={"alert-active-features-button"}>
                                                <span>View Details</span>
                                            </div>
                                        </div>
                                    </Modal.Title>
                                </div>
                            </Modal.Header>
                            <Modal.Body scrollable={true} style={{ maxHeight: "50vh", padding: " 1rem 3rem" }}>
                                <div className="upload-abstracts-main">
                                    {this.renderViewDetails()}
                                </div>
                            </Modal.Body>
                            <div className="pubmed-upload-abstracts-close-button-wrapper">
                                <Button text="Close" customColor="#000000" action={() => {
                                    this.setState({ showPop: false });
                                }} />
                            </div>
                        </div>
                    </div>
                </Modal>}
            </div>)
        }
    }

}
export default withRouter(PubMedRightAbstractsDataCard);